import { View } from "react-native";
import { Modal } from "../../components";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../types";
import { ChangeStatusEnum } from "./types";
import RemoveEmploymentOption from "../../components/MenuOption";

const RemoveEmploymentModal = ({
  visible,
  onDismiss,
  navigation,
  employmentId,
  onRemoveAndChangeStatus,
  setShowStatusChangeModal,
}: {
  visible: boolean;
  onDismiss(): void;
  navigation: NativeStackNavigationProp<RootStackParamList>;
  employmentId: string;
  onRemoveAndChangeStatus(): void;
  setShowStatusChangeModal: (value: string) => void;
}) => {
  return (
    <Modal {...{ visible, onDismiss, title: "Remove Employment" }}>
      <View className="mb-4 flex flex-col">
        <RemoveEmploymentOption
          title="Remove & Add New Employment"
          onPress={() => {
            navigation.navigate("EmploymentRemove", { id: employmentId, nextAction: "AddEmployment" });
            onDismiss();
          }}
        />
        <RemoveEmploymentOption
          title="Remove & Change Status to Unemployed"
          onPress={() => {
            onDismiss();
            onRemoveAndChangeStatus();
          }}
        />
        <RemoveEmploymentOption
          title="Remove & Change Status to Retired Member"
          onPress={() => {
            onDismiss();
            setShowStatusChangeModal(ChangeStatusEnum.RETIRED_MEMBER);
          }}
        />
        <RemoveEmploymentOption
          title="Remove & Change Status to Reserve Member"
          onPress={() => {
            onDismiss();
            setShowStatusChangeModal(ChangeStatusEnum.RESERVE_MEMBER);
          }}
        />
        <RemoveEmploymentOption
          title="Remove & Change Status to Life Member - Retired"
          onPress={() => {
            onDismiss();
            setShowStatusChangeModal(ChangeStatusEnum.LIFE_MEMBER_RETIRED);
          }}
        />
        <RemoveEmploymentOption
          title="Remove & Change Status to Life Member - Active"
          onPress={() => {
            onDismiss();
            setShowStatusChangeModal(ChangeStatusEnum.LIFE_MEMBER_ACTIVE);
          }}
        />
        <RemoveEmploymentOption
          title="Remove & Change Status to  Life Member Century"
          lastElement
          onPress={() => {
            onDismiss();
            setShowStatusChangeModal(ChangeStatusEnum.LIFE_MEMBER_CENTURY);
          }}
        />
      </View>
    </Modal>
  );
};

export default RemoveEmploymentModal;
